import { useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";

export interface ILedgerParams {
  page?: number;
  start_date?: string;
  end_date?: string;
  reference_number?: string;
  source?: string;
  branch_id?: string;
  company_id?: string;
  journal_id?: string;
  reference?: string;
  account_id?: string;
}

export const useGetGeneralLedgerList = (params: ILedgerParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: [
      "get-general-ledger-list",
      params.start_date,
      params.end_date,
      params.page,
      params.reference_number,
      params.source,
      params.branch_id,
      params.company_id,
      params.journal_id,
      params.reference,
      params.account_id,
    ],
    queryFn: async () => {
      return apiClient.get(`/api/general-ledgers`, { params });
    },
  });

export const useDownloadGeneralLedgers = (params: ILedgerParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["download-general-ledgers"],
    queryFn: async () => {
      return apiClient.get(`/api/general-ledgers/download`, { params });
    },
    enabled: false,
    gcTime: 0,
  });
